import { render, staticRenderFns } from "./ReceiptTrafficExampleDialog.vue?vue&type=template&id=4f0c106a&"
import script from "./ReceiptTrafficExampleDialog.vue?vue&type=script&lang=js&"
export * from "./ReceiptTrafficExampleDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptTrafficExampleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports